module.exports = __webpack_public_path__ + "media/images/julieta-ee17faa864f7b777d228af2badbe4f87.jpg";